import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';

export class AlterarSenhaModel {

    senha_antiga: String
    senha_nova: String
    confirmarSenha: String

    enviaAlterarSenha(alterarSenhaModel: AlterarSenhaModel): Promise<PhicubeResponse> {
        return new GatewayService().requestPost('/api/user/alterarSenha', alterarSenhaModel)
    }
}